import { render, staticRenderFns } from "./ReserveList.vue?vue&type=template&id=78c497a2&scoped=true&"
import script from "./ReserveList.vue?vue&type=script&lang=js&"
export * from "./ReserveList.vue?vue&type=script&lang=js&"
import style0 from "./ReserveList.vue?vue&type=style&index=0&id=78c497a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c497a2",
  null
  
)

export default component.exports